import axios from 'axios';
import retry from 'async-retry';
import moviedb from './moviedb';
import * as keys from './keys';

export default {
  async getMoreInfos(movie, infos) {
    // {"Title":"Inception","Year":"2010","Rated":"PG-13","Released":"16 Jul 2010","Runtime":"148 min","Genre":"Action, Adventure, Sci-Fi","Director":"Christopher Nolan","Writer":"Christopher Nolan","Actors":"Leonardo DiCaprio, Joseph Gordon-Levitt, Ellen Page, Tom Hardy","Plot":"A thief, who steals corporate secrets through use of dream-sharing technology, is given the inverse task of planting an idea into the mind of a CEO.","Language":"English, Japanese, French","Country":"USA, UK","Awards":"Won 4 Oscars. Another 152 wins & 204 nominations.","Poster":"https://images-na.ssl-images-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_SX300.jpg","Ratings":[{"Source":"Internet Movie Database","Value":"8.8/10"},{"Source":"Rotten Tomatoes","Value":"86%"},{"Source":"Metacritic","Value":"74/100"}],"Metascore":"74","imdbRating":"8.8","imdbVotes":"1,645,994","imdbID":"tt1375666","Type":"movie","DVD":"07 Dec 2010","BoxOffice":"$292,568,851","Production":"Warner Bros. Pictures","Website":"http://inceptionmovie.warnerbros.com/","Response":"True"}
    try {
      const response = await this.getInfosWithTitle(movie.title);
      let filteredInfos = null;

      if (parseInt(movie.release_date.substr(0, 4), 10) === parseInt(response.Year, 10)) {
        filteredInfos = this.filterInfos(response);
      } else {
        try {
          const id = await moviedb.getImdbId(movie);
          const responseId = await this.getInfosWithId(id);
          filteredInfos = this.filterInfos(responseId);
        } catch (error) {
          console.log(error);
        }
      }

      infos(filteredInfos);
    } catch (error) {
      console.log(error);
    }
  },
  async getInfosWithTitle(title) {
    return await retry(async bail => {
      const url = `https://www.omdbapi.com/?t=${title}&apikey=${keys.OMDB_KEY}`;
      const response = await axios.get(url, { timeout: 3000 });
      return response.data;
    }, {
      retries: 5
    });
  },
  async getInfosWithId(id) {
    return await retry(async bail => {
      const url = `https://www.omdbapi.com/?i=${id}&apikey=${keys.OMDB_KEY}`;
      const response = await axios.get(url, { timeout: 3000 });
      return response.data;
    }, {
      retries: 5
    });
  },
  filterInfos(response) {
    const {
      imdbID: imdbId = null,
      Plot: plot = null,
      Actors: actors,
      Awards: awards,
      Country: country,
      Director: director,
      Writer: writer,
      Runtime: runtime,
    } = response;

    let imdbRating = null;
    let rtRating = null;

    if (response.Ratings !== undefined) {
      imdbRating = response.Ratings.find(ratings => ratings.Source === 'Internet Movie Database');
      rtRating = response.Ratings.find(ratings => ratings.Source === 'Rotten Tomatoes');
      imdbRating = imdbRating ? imdbRating.Value : null;
      rtRating = rtRating ? rtRating.Value : null;
    }

    return {
      plot,
      imdbId,
      imdbRating,
      rtRating,
      actors,
      awards,
      country,
      director,
      writer,
      runtime,
    };
  },
};
